type Props = {
  email: string;
  onChangeEmail: () => void;
};

export function LockedEmailRow({ email, onChangeEmail }: Props) {
  return (
    <div className="signin-field">
      <label className="signin-field-label">Email</label>
      <div className="signin-locked">
        <span className="signin-locked-value">{email}</span>
        <button
          type="button"
          onClick={onChangeEmail}
          className="signin-locked-change"
        >
          Change
        </button>
      </div>
    </div>
  );
}
